import { ApiPath } from 'enums';
import env from '../environments/env';
import { Get, Post, Put } from 'utils';

export const getAccountCategories = async ({ ...query }) => {
  const res = await Get(`${ApiPath.AccountCategory}`, query, null, env.API_URL_ACCOUNTING);
  return res.data;
};

export const getAccounts = async ({ ...query }) => {
  const res = await Get(`${ApiPath.Account}`, query, null, env.API_URL_ACCOUNTING);
  return res.data;
};

export const createAccount = async ({ ...body }) => {
  const res = await Post(`${ApiPath.Account}/admin`, body);
  return res.data;
};

export const updateAccount = async ({ accountId, ...body }) => {
  const res = await Put(`${ApiPath.Account}/${accountId}`, { ...body }, null, env.API_URL_ACCOUNTING);
  return res.data;
};

export const getAccountByAccountId = async ({ accountId }) => {
  const res = await Get(`${ApiPath.Account}/${accountId}`, null, env.API_URL_ACCOUNTING);
  return res.data;
};
